import React from 'react';
import ReactDOM from 'react-dom';
import styled, {ThemeProvider} from 'styled-components';
import Formulario from '../componentes/Form';
import sendCounter from '../componentes/Counter';
import ConverteURL from '../modulos/ConverteURL.js';

/**
 * Formatos da landing page.
 * @type {{mobile: string, tablet: string, desktop: string}}
 */

// Define o limite de campos do fomulário
const lpLimiteCampos = 999;

const mediaQueries = {
	mobile: '(max-width: 800px)',
	tablet: '(max-width: 1400px)',
	desktop: '(min-width: 1401px)'
};

/**
 * Componentes estilizados.
 */
const
	Landing = styled.div`
		background-color: ${props => props.fundo};
	`,
	Layout = styled.div`
		display: flex;
		flex-wrap: wrap;
		max-width: 1400px;
		width: 90%;
		margin: 0 auto;
		color: ${props => props.corFonte};
		font-family: "Open Sans", Sans-Serif;
		min-height: 100vh;

		${props => props.theme.mode === 'mobile' ? `
			flex-wrap: nowrap;
			flex-direction: column;
			width: 100%;
		` : ''}
	`,
	Main = styled.div`
		margin-top: 45px;
		margin-bottom: 40px;
		max-width: calc(100% - 440px - 160px);
		width: 100%;
		font-size: 0;

		& + & {
			margin-top: 40px;
		}

		${props => ['tablet', 'mobile'].includes(props.theme.mode) ? `
			max-width: calc(100% - 370px - 135px);
		` : ''}

		${props => props.theme.mode === 'mobile' ? `
			max-width: 100%;
			text-align: center;
			margin-bottom: 0;
		` : ''}
	`,
	Logo = styled.div`
		margin-bottom: 35px;
		max-width: 200px;

		a img {
			max-height: 84px;
			max-width: 370px;

			${props => props.theme.mode === 'mobile' && `
				width: auto;
			`}
		}

		${props => props.theme.mode === 'mobile' && `
			text-align: center;
			display: inline-block;
		`}
	`,
	Form = styled(Formulario)`
		width: 100%;
		background-color: ${props => props.fundo};
		color: ${props => props.corForn};
		text-align: center;
		padding: 45px 40px;
		max-width: 440px;
		margin-left: auto;

		p {
			font-size: 18px;
			font-weight: 700;
		}

		${props => ['tablet', 'mobile'].includes(props.theme.mode) ? `
			max-width: 370px;
			padding-left: 30px;
			padding-right: 30px;
		` : ''}

		${props => props.theme.mode === 'mobile' ? `
			max-width: 100%;
		` : ''}
	`,
	TituloForm = styled.b`
		font-size: 36px;
		margin-bottom: 30px;
		display: block;

		${props => ['tablet', 'mobile'].includes(props.theme.mode) ? `
			font-size: 30px;
		` : ''}
	`,
	Campo = styled.input`
		width: 100%;
		border: none;
		background-color: white;
		color: ${props => props.theme.text};
		padding: 18px 20px;
		margin-bottom: 20px;

		::placeholder {
			font-style: italic;
		}
	`,
	CallToAction = styled.button`
		border: none;
		background-color: ${props => props.fundo};
		color: ${props => props.cor};
		text-transform: uppercase;
		width: 100%;
		padding: 22px;
		font-weight: 700;
		font-size: 14px;
		cursor: pointer;

		&:hover {
			background-color: ${props => props.fundo}cc;
		}
	`,
	TextoAposCallToAction = styled.pre`
		font-family: "Open Sans", Sans-Serif;
		font-style: italic;
		font-size: 16px;
		color: ${props => props.corFornACTA};
		margin-top: 20px;
		line-height: 1.3;
		max-width: 370px;
		white-space: pre-line;
	`,
	Chamada = styled.h1`
		line-height: .96em;
		margin: 0;
		color: ${props => props.corFonte};
		font-size: ${props => props.theme.mode === 'mobile' ? `${parseInt(props.tamanhoFonte.replace('px', '')) - 10 }px` : props.tamanhoFonte};
		word-break: ${props => props.theme.mode === 'mobile' ? 'break-word' : 'normal'};
		font-family: "Open Sans", Sans-Serif;
		margin-bottom: 25px;

		${props => ['tablet', 'mobile'].includes(props.theme.mode) ? `
			font-size: ${props => (parseInt(props.tamanhoFonte) * (50 / 60)) + 'px'};
		` : ''}

		${props => props.theme.mode === 'mobile' ? `
			font-size: ${props => (parseInt(props.tamanhoFonte) * (40 / 60)) + 'px'};
			padding: 0 30px;
		` : ''}
	`,
	TextoApoio = styled.pre`
		margin: 25px 0 35px;
		color: ${props => props.corFonte};
		font-size: ${props => props.tamanhoFonte};
		font-family: "Open Sans", Sans-Serif;
		line-height: 1.3;
		white-space: pre-line;
		max-width: 700px;
		word-break: ${props => props.theme.mode === 'mobile' ? 'break-word' : 'normal'};

		${props => props.theme.mode === 'mobile' ? `
			font-size: ${props => (parseInt(props.tamanhoFonte) * (16 / 18)) + 'px'};
			padding: 0 30px;
		` : ''}
	`,
	Imagem = styled.img`
		width: 100%;
		height: auto;
	`,
	Contato = styled.div`
		margin-top: 40px;

		${props => props.theme.mode === 'mobile' ? `
			margin-top: 0;
		` : ''}
	`,
	Telefone = styled.div`
		font-size: 18px;
		display: flex;
		color: ${props => props.corFonte};

		span a {
			text-decoration: none;
			color: ${props => props.corFonte};
		}

		${props => props.theme.mode === 'mobile' ? `
			flex-direction: column;
			align-items: center;
		` : ''}
	`,
	Whatsapp = styled.div`
		font-size: 18px;
		display: flex;
		margin-top: 10px;
		color: ${props => props.corFonte};

		span a {
			text-decoration: none;
			color: ${props => props.corFonte};
		}

		${props => props.theme.mode === 'mobile' ? `
			flex-direction: column;
			align-items: center;
		` : ''}
	`,
	IconeContato = styled.div`
		margin-right: 8px;

		> * {
			border-radius: 50%;
		}
	`,
	Email = styled.a`
		color: ${props => props.corFonte};
		text-decoration: none;
		border-bottom: 1px solid;
		font-size: 18px;

		${props => props.theme.mode === 'mobile' ? `
			margin-top: 25px;
			display: inline-block;
		` : ''}
	`,
	TermosDeUso = styled.div`
		display: flex;
    align-items: center;
    justify-content: center;
		font-style: italic;
		font-size: 16px;
		margin-top: 20px;

		label{
			color: ${props => props.corFonte};
			font-size: ${(18 / 16)}rem;
			margin: 0 5px;
		}

		input{
			width: 18px;
			height: 18px;
		}

		a {
			font-size: ${(18 / 16)}rem;
			color: ${props => props.corFonte};
			text-decoration: underline;

			&:hover {
				color: ${props => props.corFonte}cc;
			}
		}
	`,
	RedesSociais = styled.div`
		margin-top: 20px;
		display: flex;

		> * + * {
			margin-left: 10px;
		}

		${props => props.theme.mode === 'mobile' ? `
			margin: 30px;
			justify-content: center;

			> * + * {
				margin-left: 23px;
			}
		` : ''}
	`,
	Facebook = styled.a``,
	Twitter = styled.a``,
	Instagram = styled.a``,
	Linkedin = styled.a``,

	WidgetWhatsapp = styled.a`
		box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
		margin: 10px;
		position: fixed;
		bottom: 30px;
		right: 40px;
		font-family: "Open Sans", Sans-Serif;
		cursor: pointer;

		.widget{
			position: relative;
			width: 80px;
			height: 80px;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 50%;
			background: rgba(37, 211, 102, 1);
			transform: scale(1);
			animation: pulse-green 2s infinite;

			&::after, &::before {
				position: absolute;
				left: -80px;
				display: none;
				transition: all ease .3s;
			}

			&::before {
				content: '';
				border-width: 8px 8px 0px 8px;
				border-style: solid;
				border-color: rgba(0, 0, 0, 0.9) transparent transparent transparent;
				margin-left: 60px;
				top: 33px;
				transform: rotate(-90deg);
			}

			&::after {
				content: attr(data-tooltip);
				background: rgba(0, 0, 0, 0.9);
				top: 54px;
				font-size: 14px;
				font-weight: normal;
				text-align: center;
				line-height: normal;
				text-transform: uppercase;
				width: 180px;
				margin-left: -132px;
				padding: 8px;
				color: #fff;
				transform: translateY(-100%);
				border-radius: 5px;
			}

			&:hover::after,
			&:hover::before {
				display: block;
			}

			&:hover{
				animation: none;
			}

			svg{
				width: 40px;
  			height: 40px;
			}
		}

		@keyframes pulse-green {
			0% {
				-moz-box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
				box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
			}
			70% {
					-moz-box-shadow: 0 0 0 10px rgba(37, 211, 102, 0);
					box-shadow: 0 0 0 10px rgba(37, 211, 102, 0);
			}
			100% {
					-moz-box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
					box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
			}
		}

		${props => props.theme.mode === 'mobile' ? `
			bottom: 30px;
    	right: 30px;

			.widget{
				width: 60px;
				height: 60px;

				svg{
					width: 30px;
					height: 30px;
				}
			}
		` : ''}
	`
;

/**
 * Template Básico de landing page.
 */
class TemplateBasicov2 extends React.Component {
	/**
	 * Construtor da classe. Cria o estado e, se não estiver no editor, adiciona o handler para quando a janela for redimensionada.
	 * @param props
	 */
	constructor(props) {
		super(props);

		/**
		 * Modo da landing page.
		 * @type {{mode: string}}
		 */
		this.state = {
			mode: this.getMode()
		};

		if(this.props.editorActivePreviewTab) {
			window.addEventListener('resize', () => this.onResize());
		}
		/**
		 * Elemento raíz da landing page.
		 * @type {{current: HTMLElement}}
		 */
		this.root = React.createRef();

	}


	componentDidMount() {
		if (this.props.urlVisualizacao){
			sendCounter(this.props.urlVisualizacao);
		}
  }

	/**
	 * Ao redimensionar a tela, verifique o modo.
	 */
	onResize() {
		this.setState({
			mode: this.getMode()
		})
	}

	/**
	 * Confere as media queries com o tamanho atual da janela.
	 * @returns {string} Nome do modo atual.
	 */
	getMode() {

		return this.props.editorActivePreviewTab ? (
			this.props.editorActivePreviewTab !== "mobile" ? (
				'tablet'
			) : (
				'mobile'
			)
		) : (
			Object.keys(mediaQueries).find(mediaQueryMode => window.matchMedia(mediaQueries[mediaQueryMode]).matches)
		);
	}

	toTelefone(value) {
		return value
			.replace(/\D/g, '')
	}

	/**
	 * Renderiza o formulário.
	 * @returns {ReactElement}
	 */
	form() {

		return (
			<React.Fragment>
				{
					// Bloqueia os campos do formulário após limite da length
					this.props.camposFormulario.filter(e => e.enabled).length >= lpLimiteCampos
						? this.props.camposFormulario.filter(e => !e.enabled).map(e => e.editable = true)
						: this.props.camposFormulario.filter(e => !e.enabled).map(e => e.editable = false)
				}

				<Form
					fundo={this.props.campos.corFundoForm}
					mode={this.state.mode}
					action={this.props.urlPost}
					tipoRetorno={this.props.tipoRetorno}
					valorRetorno={this.props.valorRetorno}
					corForn={this.props.campos.corTituloForm}
				>

					{this.props.campos.tituloForm && (
						<TituloForm>
							{this.props.campos.tituloForm}
						</TituloForm>
					)}

					{this.props.camposFormulario.map(campo => {
						let [primeiraLetra, ...campoCamelCase] = campo.placeholder;

						return campo.enabled && (
							<Campo
								key={campo.name}
								aria-label={campo.placeholder}
								type={campo.name === 'email' ? "email" : "text"}
								name={campo.name}
								placeholder={
									primeiraLetra.toUpperCase()
									+ campoCamelCase.join('')
									+ (campo.required ? '*' : '')
								}
								required={campo.required}
							/>
						)
					})}

					<CallToAction
						type={!this.props.editorActivePreviewTab ? "submit" : "button"}
						fundo={this.props.campos.fundoCallToAction}
						cor={this.props.campos.corCallToAction}
					>
						{this.props.campos.textoCallToAction}
					</CallToAction>

					{this.props.campos.textoAposCallToAction && this.props.campos.termos && (
						<TextoAposCallToAction corFornACTA={this.props.campos.corTextoAposCallToAction}>
							{this.props.campos.textoAposCallToAction}
						</TextoAposCallToAction>
					)}

					{this.props.campos.termos && (
						<TermosDeUso corFonte={this.props.campos.corTextoAposCallToAction}>
							<input type="checkbox" id="termos_checkbox" required />
							<label htmlFor="termos_checkbox">
								Li e aceito os
							</label>
							<a
								href={ConverteURL(this.props.campos.termos)}
							  title="Termos de uso"
								target="_blank"
								rel="noopener noreferrer"
							>
								termos de uso
							</a>
						</TermosDeUso>
					)}
				</Form>
			</React.Fragment>
		)
	}

	/**
	 * Renderiza o JSX que deve estar antes do formulário no modo `mobile`.
	 * @returns {ReactElement}
	 */
	beforeForm() {
		return (
			<React.Fragment>
				{this.props.campos.hasLogo && this.props.campos.logo && (
					<Logo>
						<a
							href={ConverteURL(this.props.campos.urlLogo)}
						  title={this.props.campos.titulo}
							target="_blank"
							rel="noopener noreferrer"
						>
							<img
								src={this.props.campos.logo}
								alt={this.props.campos.titulo}
							/>
						</a>
					</Logo>
				)}

				{this.props.campos.chamada && (
					<Chamada tamanhoFonte={this.props.campos.tamanhoFonteTitulo} corFonte={this.props.campos.corFonteTitulo}>
						{this.props.campos.chamada}
					</Chamada>
				)}

				{this.props.campos.textoApoio && (
					<TextoApoio tamanhoFonte={this.props.campos.tamanhoFonteTextoApoio} corFonte={this.props.campos.corFonteTextoApoio}>
						{this.props.campos.textoApoio}
					</TextoApoio>
				)}

				{this.props.campos.hasImagem && this.props.campos.imagem && (
					<Imagem src={this.props.campos.imagem} alt={this.props.campos.tituloLanding}/>
				)}
			</React.Fragment>
		)
	}

	/**
	 * Renderiza o JSX que deve estar após do formulário no modo `mobile`.
	 * @returns {ReactElement}
	 */
	afterForm() {
		return (
			<React.Fragment>
				<Contato>
					{this.props.campos.telefone && (
						<Telefone corFonte={this.props.campos.corFonteTextoApoio}>
							<IconeContato>
								<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30">
									<path fill="#989898" d="M15 0a15 15 0 1 1 0 30 15 15 0 0 1 0-30z"/>
									<path fill="#FFF" d="M22.3 17.6L19.6 16c-.4-.1-.7-.2-1 .2L17.3 18c-.2.2-.5.3-.9 0-.4-.2-1.6-.7-3.1-2.1-1.2-1.1-2-2.5-2.2-3-.2-.4 0-.6.2-.8l.7-.7.4-.6c.1-.3 0-.5 0-.8l-1.1-3c-.3-.9-.7-.8-1-.8h-.7c-.3 0-.7 0-1 .4C8 7 7 8 7 10c0 2 1.3 4 1.5 4.3.2.3 2.6 4.7 6.6 6.5 4 1.8 4 1.2 4.8 1.2.8 0 2.4-1 2.8-1.9.4-.9.4-1.7.3-1.9 0-.2-.4-.3-.7-.5z"/>
								</svg>
							</IconeContato>
							<span>
								<a href={`tel:${this.toTelefone(this.props.campos.telefone)}`} target="_black">
									{this.props.campos.telefone}
								</a>
							</span>
						</Telefone>
					)}

					{this.props.campos.whatsapp && (
						<Whatsapp corFonte={this.props.campos.corFonteTextoApoio}>
							<IconeContato>
								<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
									<path fill="#2daf81" d="M12.03 6.17a5.77 5.77 0 0 0-4.75 9.05l-.58 2.13 2.18-.57a5.78 5.78 0 1 0 3.15-10.6zm3.4 8.25c-.15.4-.84.77-1.18.82-.3.04-.67.06-1.09-.07-.25-.08-.57-.19-.99-.36-1.74-.76-2.87-2.5-2.96-2.62-.09-.12-.7-.94-.7-1.8s.44-1.27.6-1.44a.64.64 0 0 1 .46-.22h.33c.11.01.25-.03.4.3l.53 1.3c.04.08.07.18.01.3-.05.11-.08.19-.17.29l-.26.3c-.09.09-.18.18-.08.36.1.17.45.74.97 1.2.66.59 1.22.77 1.4.86s.27.07.37-.05c.1-.11.43-.5.55-.68.11-.17.23-.14.39-.08s1 .47 1.18.56.29.13.33.2c.05.07.05.42-.1.83zM12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm.03 18.88c-1.16 0-2.3-.3-3.32-.84L5.03 19l.99-3.6a6.92 6.92 0 0 1 6-10.4 6.9 6.9 0 0 1 6.94 6.94 6.95 6.95 0 0 1-6.93 6.94z"/>
								</svg>
							</IconeContato>
							<span>
								<a href={`https://api.whatsapp.com/send?phone=55${this.toTelefone(this.props.campos.whatsapp)}`} target="_black">
									{this.props.campos.whatsapp}
								</a>
							</span>
						</Whatsapp>
					)}

					{this.props.campos.email && (
						<Email href={'mailto:' + this.props.campos.email} corFonte={this.props.campos.fundoCallToAction}>
							{this.props.campos.email}
						</Email>
					)}
				</Contato>

				<RedesSociais>
					{this.props.campos.facebook && (
						<Facebook
							href={/http/.test(this.props.campos.facebook)
								? this.props.campos.facebook
								: `https://${this.props.campos.facebook}`
							}
							target="_blank"
							title="Facebook"
							rel="noopener noreferrer"
						>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 235 234" width="40" height="40">
								<path fill="#5f81c4" d="M117.4.6a116.7 116.7 0 1 0 0 233.4 116.7 116.7 0 0 0 0-233.4z"/>
								<path fill="#fff" d="M127.7 90V79c0-5.5 3.5-6.7 6-6.7h15.6V48.6l-21.4-.1c-23.7 0-29 17.7-29 29V90H85v27.7H99v69h27.6v-69h20.5l1-11 1.5-16.7z"/>
							</svg>
						</Facebook>
					)}

					{this.props.campos.twitter && (
							<Twitter
								href={/http/.test(this.props.campos.twitter)
									? this.props.campos.twitter
									: `https://${this.props.campos.twitter}`
								}
								target="_blank"
								title="Twitter"
								rel="noopener noreferrer"
							>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 235 234" width="40" height="40">
									<path fill="#43bcee" d="M117.4.6a116.7 116.7 0 1 0 0 233.4 116.7 116.7 0 0 0 0-233.4z"/>
									<path fill="#fff" d="M186.5 81.7c-5 2.2-10.5 3.7-16.3 4.4a28 28 0 0 0 12.5-15.5 57.3 57.3 0 0 1-18 6.8 28.5 28.5 0 0 0-49 19.1c0 2.2.2 4.3.7 6.4a81 81 0 0 1-58.5-29.2 27.5 27.5 0 0 0 8.8 37.3c-4.7-.2-9-1.4-12.9-3.5v.3a28.3 28.3 0 0 0 22.7 27.4 29.2 29.2 0 0 1-12.7.5c3.6 11 14 19.2 26.5 19.4a57.4 57.4 0 0 1-42 11.6 81.3 81.3 0 0 0 43.4 12.5 79 79 0 0 0 80.7-79.4v-3.6a57 57 0 0 0 14.1-14.5z"/>
								</svg>
							</Twitter>
					)}

					{this.props.campos.instagram && (
							<Instagram
								href={/http/.test(this.props.campos.instagram)
									? this.props.campos.instagram
									: `https://${this.props.campos.instagram}`
								}
								target="_blank"
								title="Instagram"
								rel="noopener noreferrer"
							>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 235 234" width="40" height="40">
									<defs>
										<linearGradient id="grd1" x1="34.9" x2="199.9" y1="199.8" y2="34.8" gradientUnits="userSpaceOnUse">
											<stop offset="0" stopColor="#fcc440"/>
											<stop offset="1" stopColor="#ab26f7"/>
										</linearGradient>
									</defs>
									<path fill="url(#grd1)" d="M.7 117.3a116.7 116.7 0 1 0 233.4 0 116.7 116.7 0 0 0-233.4 0z"/>
									<path fill="#fff" d="M173 159.7c0 7.3-5.9 13.3-13.2 13.3H75c-7.3 0-13.3-6-13.3-13.3v-56.6h20.7a37.1 37.1 0 0 0-2.8 14.2 37.8 37.8 0 1 0 72.8-14.2H173v56.6zm-75.3-56.6a24.3 24.3 0 1 1 39.5 28.4A24.3 24.3 0 0 1 97.7 103zm69.8-39h3v23.4l-23.3.1-.1-23.4h20.4zm-7.7-16H75c-14.8 0-26.7 12-26.7 26.8V159.7c0 14.7 12 26.7 26.7 26.7h84.8c14.7 0 26.7-12 26.7-26.7V74.9c0-14.8-12-26.7-26.7-26.7z"/>
								</svg>
							</Instagram>
					)}

					{this.props.campos.linkedin && (
							<Linkedin href={/http/.test(this.props.campos.linkedin)
									? this.props.campos.linkedin
									: `https://${this.props.campos.linkedin}`
								}
								target="_blank"
								title="Linkedin"
								rel="noopener noreferrer"
							>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 235 234" width="40" height="40">
									<path fill="#2796cf" d="M117.4.6a116.7 116.7 0 1 0 0 233.4 116.7 116.7 0 0 0 0-233.4z"/>
									<path fill="#fff" d="M51.2 112.8v67.7h32.3V88.3H51.2zm16.2-70.6a16.1 16.1 0 1 0 0 32.3 16.1 16.1 0 0 0 0-32.3zm121.4 74.4c-2.2-17.3-10.2-28.3-33.7-28.3-13.9 0-23.3 5.2-27 12.5h-.5V88.3H102v92.2h26.9v-45.7c0-12 2.3-23.7 17.2-23.7 14.6 0 15.8 13.8 15.8 24.5v44.9h27.7v-50.7c0-4.7-.2-9.1-.7-13.2z"/>
								</svg>
							</Linkedin>
					)}
				</RedesSociais>
			</React.Fragment>
		)
	}

	/**
	 * Renderiza a landing page.
	 * @returns {ReactElement}
	 */
	render() {
		return (
			<ThemeProvider theme={{mode: this.state.mode}}>
				<Landing ref={this.root} fundo={this.props.campos.corFundo}>
					{this.state.mode === 'mobile' ? (
						<Layout corFonte={this.props.campos.corFonteTextoApoio}>
							<Main>
								{this.beforeForm()}
							</Main>
							{this.form()}
							<Main>
								{this.afterForm()}
							</Main>
						</Layout>
					) : (
						<Layout corFonte={this.props.campos.corFonteTextoApoio}>
							<Main>
								{this.beforeForm()}
								{this.afterForm()}
							</Main>
							{this.form()}
						</Layout>
					)}

					{this.props.campos.widgetWhatsappNumero && this.props.campos.widgetWhatsappNumero.length > 5 && (
							<WidgetWhatsapp
								href={`https://api.whatsapp.com/send/?phone=${this.props.campos.widgetWhatsappNumero}&text=${this.props.campos.widgetWhatsappMensagem}`}
								target="_blank"
								rel="noopener noreferrer"
							>
								<div className="widget" data-tooltip="envie uma mensagem">
									<svg width="33" height="34" viewBox="0 0 33 34" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M28.2461 5.57949C25.282 2.52821 21.1846 0.871796 17 0.871796C8.10766 0.871796 0.958945 8.10769 1.04612 16.9128C1.04612 19.7026 1.83074 22.4051 3.13843 24.8462L0.871765 33.1282L9.32817 30.9487C11.682 32.2564 14.2974 32.8667 16.9128 32.8667C25.7179 32.8667 32.8666 25.6308 32.8666 16.8256C32.8666 12.5538 31.2102 8.54359 28.2461 5.57949ZM17 30.1641C14.6461 30.1641 12.2923 29.5538 10.2871 28.3333L9.76407 28.0718L4.70766 29.3795L6.01535 24.4103L5.66664 23.8872C1.83074 17.6974 3.66151 9.50256 9.93843 5.66667C16.2154 1.83077 24.323 3.66154 28.1589 9.93846C31.9948 16.2154 30.1641 24.3231 23.8871 28.159C21.882 29.4667 19.441 30.1641 17 30.1641ZM24.6718 20.4872L23.7128 20.0513C23.7128 20.0513 22.3179 19.441 21.4461 19.0051C21.3589 19.0051 21.2718 18.9179 21.1846 18.9179C20.923 18.9179 20.7487 19.0051 20.5743 19.0923C20.5743 19.0923 20.4871 19.1795 19.2666 20.5744C19.1795 20.7487 19.0051 20.8359 18.8307 20.8359H18.7436C18.6564 20.8359 18.482 20.7487 18.3948 20.6615L17.9589 20.4872C17 20.0513 16.1282 19.5282 15.4307 18.8308C15.2564 18.6564 14.9948 18.4821 14.8205 18.3077C14.2102 17.6974 13.6 17 13.1641 16.2154L13.0769 16.041C12.9897 15.9538 12.9897 15.8667 12.9025 15.6923C12.9025 15.5179 12.9025 15.3436 12.9897 15.2564C12.9897 15.2564 13.3384 14.8205 13.6 14.559C13.7743 14.3846 13.8615 14.1231 14.0359 13.9487C14.2102 13.6872 14.2974 13.3385 14.2102 13.0769C14.123 12.641 13.0769 10.2872 12.8154 9.7641C12.641 9.50256 12.4666 9.41538 12.2051 9.32821H11.2461C11.0718 9.32821 10.8974 9.41539 10.723 9.41539L10.6359 9.50256C10.4615 9.58974 10.2871 9.7641 10.1128 9.85128C9.93843 10.0256 9.85125 10.2 9.67689 10.3744C9.06664 11.159 8.71792 12.1179 8.71792 13.0769C8.71792 13.7744 8.89228 14.4718 9.15382 15.0821L9.241 15.3436C10.0256 17 11.0718 18.4821 12.4666 19.7897L12.8154 20.1385C13.0769 20.4 13.3384 20.5744 13.5128 20.8359C15.3436 22.4051 17.4359 23.5385 19.7897 24.1487C20.0513 24.2359 20.4 24.2359 20.6615 24.3231H21.5333C21.9692 24.3231 22.4923 24.1487 22.841 23.9744C23.1025 23.8 23.2769 23.8 23.4513 23.6256L23.6256 23.4513C23.8 23.2769 23.9743 23.1897 24.1487 23.0154C24.323 22.841 24.4974 22.6667 24.5846 22.4923C24.7589 22.1436 24.8461 21.7077 24.9333 21.2718V20.6615C24.9333 20.6615 24.8461 20.5744 24.6718 20.4872Z" fill="white"/>
									</svg>
								</div>
							</WidgetWhatsapp>
						)
					}
				</Landing>
			</ThemeProvider>
		);
	}
}

if (!!document.querySelector('#landing-page')) {
	window.landingPage = ReactDOM.render(<TemplateBasicov2 {...window.dadosLandingPage} />, document.querySelector('#landing-page'));
}

export default TemplateBasicov2
